import Vue from 'vue';
import CommentNotification from '../ui/Components/CommentNotification.vue';

/** create event bus to handle all notification from one place */
export const bus = new Vue();

export function notification(_self) {
  bus.$on('comment_notification', (comment) => {
    const title = 'You have new comment';
    const variant = 'warning';
    let link = '';
    if (comment.jobId) {
      link = `/jobs/${comment.jobId}`;
    } else if (comment.entityId) {
      link = `/files/${comment.entityId.size}/${comment.entityId.checksum}`;
    } else {
      link = '/home';
    }
    const h = _self.$createElement;
    const body = h(CommentNotification, {
      props: {
        comment,
      },
    });
    _self.$bvToast.toast([body], {
      title,
      autoHideDelay: 5000,
      variant,
      appendToast: true,
      solid: true,
      to: link,
    });
  });
  bus.$on('job_notification', (data) => {
    let { title } = data;
    let { body } = data;
    const variant = data.type;
    if (data.data) {
      // customized job notification here
      if (data.title === 'job-notification') {
        title = 'Job Completed Successfully';
        const h = _self.$createElement;
        const trStyle = {
          style: {
            'line-height': '0px',
          },
        };
        const tdStyle = {
          style: {
            'font-size': '0.8em',
          },
        };
        const nodes = h(
          'table',
          { class: ['table'] },
          [
            h('tbody', [
              h('tr', trStyle, [
                h('td', tdStyle, 'Name'),
                h('td', tdStyle, data.data.name),
              ]),
              h('tr', trStyle, [
                h('td', tdStyle, 'Finished'),
                h('td', tdStyle, data.data.dateFinished),
              ]),
            ]),
          ],
        );
        body = [nodes];
      }
    }
    _self.$bvToast.toast(body, {
      title,
      autoHideDelay: 5000,
      variant,
      appendToast: true,
      solid: true,
      to: `/jobs/${data.data.jobId}`,
    });
  });
}
